import get from 'lodash/get';

import {
  CLEAR_MEMBERS_LIST_REQUEST,
  CLEAR_POSTS_LIST_REQUEST,
  COMMUNITY_DROP_MESSAGES,
  COMMUNITY_SET_DOCUMENT_ATTACHMENT,
  GET_COMMUNITY_CHATS_SUCCESS,
  GET_COMMUNITY_CHAT_BY_ID_SUCCESS,
  GET_COMMUNITY_CHAT_INFO_BY_ID_SUCCESS,
  GET_COMMUNITY_LIST_SUCCESS,
  GET_COMMUNITY_MEMBERS_LIST_FOR_FILTER_SUCCESS,
  GET_COMMUNITY_MEMBERS_LIST_SUCCESS,
  GET_POSTS_COMMENTS_LIST_SUCCESS,
  GET_POSTS_LIST_SUCCESS,
  GET_POST_BY_ID_SUCCESS,
  REMOVE_COMMENT_SUCCESS,
  REMOVE_POST_SUCCESS, // UPDATE_COMMUNITY_SUCCESS,
} from '../actionConstants';

import { getUniqueValues } from '../utils';

const defaultState = {
  list: {},
  unpagedList: [],
  postsList: {},
  postsCommentsList: {},
  communityMembersList: {},
  communityChats: {
    results: [],
  },
  currentChat: {},
  newMessage: {
    documentId: null,
    documentName: null,
  },
};

export default (state = defaultState, action) => {
  const {
    type,
    res,
    // id,
    isWithoutPagination,
    postId,
    commentId,
    isClearPrev,
    withReset,
    isPostRemoval,
  } = action;

  switch (type) {
    case GET_COMMUNITY_LIST_SUCCESS: {
      if (isWithoutPagination) {
        return { ...state, unpagedList: res?.data };
      }
      return { ...state, list: res?.data };
    }

    case GET_POSTS_LIST_SUCCESS: {
      if (isClearPrev) {
        return { ...state, postsList: res?.data };
      }

      const prevResults = state?.postsList?.results || [];
      const newResults = res?.data?.results || [];
      const results = [...prevResults, ...newResults];

      const postsList = {
        ...res.data,
        results,
      };

      return { ...state, postsList };
    }

    case CLEAR_POSTS_LIST_REQUEST:
      return { ...state, postsList: {} };

    case REMOVE_POST_SUCCESS:
    case GET_POST_BY_ID_SUCCESS: {
      const posts = Array.from(state.postsList.results || []);
      const postIndex = posts.findIndex(({ id }) => id === postId);
      if (postIndex === -1) return state;
      if (isPostRemoval) {
        posts.splice(postIndex, 1);
      } else {
        posts.splice(postIndex, 1, res.data);
      }
      return { ...state, postsList: { ...state.postsList, results: posts } };
    }

    case REMOVE_COMMENT_SUCCESS: {
      const comments = Array.from(state.postsCommentsList[postId].results);
      const updatedCommentsList = comments.filter(({ id }) => id !== commentId);

      return {
        ...state,
        postsCommentsList: {
          ...state.postsCommentsList,
          [postId]: {
            ...state.postsCommentsList[postId],
            results: updatedCommentsList,
          },
        },
        postsList: {
          ...state.postsList,
          results: state.postsList.results.map((post) => {
            if (post.id === postId) {
              return {
                ...post,
                commentsCount: post.commentsCount - 1,
              };
            }
            return post;
          }),
        },
      };
    }

    case GET_COMMUNITY_CHATS_SUCCESS: {
      const results = (
        withReset
          ? get(res, 'data.results')
          : getUniqueValues(
              [...state.communityChats.results, ...get(res, 'data.results')],
              'id',
            )
      ).sort((a, b) => Date.parse(b.updatedAt) - Date.parse(a.updatedAt));
      return {
        ...state,
        communityChats: {
          count: get(res, 'data.count'),
          next: get(res, 'data.next'),
          previous: get(res, 'data.previous'),
          results,
        },
      };
    }

    case GET_COMMUNITY_CHAT_INFO_BY_ID_SUCCESS: {
      const currentChatInfo = res?.data?.results?.[0] ?? {};
      return {
        ...state,
        currentChatInfo,
      };
    }

    case GET_COMMUNITY_MEMBERS_LIST_SUCCESS: {
      if (state.communityMembersList?.results) {
        const prevResults = state?.communityMembersList?.results || [];
        const newResults = res?.data?.results || [];
        const results = [...prevResults, ...newResults];

        const communityMembersList = {
          ...res.data,
          results,
        };
        return { ...state, communityMembersList };
      }
      return { ...state, communityMembersList: res?.data };
    }

    case GET_COMMUNITY_MEMBERS_LIST_FOR_FILTER_SUCCESS: {
      return { ...state, communityMembersListForFilter: res?.data };
    }

    case CLEAR_MEMBERS_LIST_REQUEST:
      return { ...state, communityMembersList: {} };

    // comment code above to avoid re-rendering when affecting options and ect. if needed - then api need to adjust payload like on GET request

    // case UPDATE_COMMUNITY_SUCCESS: {
    //   const updatedIndex = state?.list?.results
    //     ?.map(({ id }) => id)
    //     ?.indexOf(id);

    //   if (updatedIndex < 0) return state;
    //   const newList = [...(state?.list?.results ?? [])];
    //   newList?.splice(updatedIndex, 1, res?.data);

    //   return { ...state, list: { ...state?.list, results: newList } };
    // }

    case GET_POSTS_COMMENTS_LIST_SUCCESS: {
      return {
        ...state,
        postsCommentsList: {
          ...state?.postsCommentsList,
          [postId]: res?.data,
        },
      };
    }

    case GET_COMMUNITY_CHAT_BY_ID_SUCCESS: {
      const prevItems = state?.currentChat?.results ?? [];

      const results = withReset
        ? get(res, 'data.results')
        : [...prevItems, ...get(res, 'data.results')];
      return {
        ...state,
        currentChat: {
          count: get(res, 'data.count'),
          next: get(res, 'data.next'),
          previous: get(res, 'data.previous'),
          results,
        },
      };
    }
    case COMMUNITY_SET_DOCUMENT_ATTACHMENT: {
      return {
        ...state,
        newMessage: {
          documentId: action.documentId,
          documentName: action.documentName,
        },
      };
    }

    case COMMUNITY_DROP_MESSAGES:
      return {
        ...state,
        currentChat: {},
      };

    default:
      return state;
  }
};
